import { useMutation as r } from "react-query";
import { useEnvironment as s } from "../../common/hooks/environment/useEnvironment.js";
function i() {
  const {
    backendBaseUrl: o
  } = s();
  return r(
    async (e) => {
      const t = await fetch(`${o}/oauth/validation/`, {
        method: "post",
        body: JSON.stringify({
          shared_secret: e.sharedSecret,
          validation_code: e.code
        })
      });
      if (t.status !== 200)
        throw new Error("Request failed");
      return t.json();
    }
  );
}
export {
  i as useCodeRequest
};
//# sourceMappingURL=useCodeRequest.js.map
